import UpcomingAppointments from "./UpcomingAppointments";

export default UpcomingAppointments;
